import ServiceSlider from "./slider.js";
import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { useLanguage } from '../context/LanguageContext.js';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

export default function Contact(){
  const { t, language} = useLanguage();
  const location = useLocation();
  const canonicalUrl = window.location.origin + location.pathname;
    /*logic  */
    const [mailtoOpened, setMailtoOpened] = useState(false);
  const [lastSubmissionTime, setLastSubmissionTime] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
    
      const [errors, setErrors] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
    
      const [touched, setTouched] = useState({
        name: false,
        email: false,
        phone: false,
        message: false
      });
      const [isSending, setIsSending] = useState(false);
      const [sendStatus, setSendStatus] = useState(null); // 'success' or 'error'
      const validateField = (name, value) => {
        let error = '';
        
        switch (name) {
          case 'name':
            if (!value.trim()) error = 'Name is required';
            break;
          case 'email':
            if (!value.trim()) {
              error = 'Email is required';
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
              error = 'Invalid email format';
            }
            break;
          case 'phone':
            if (!value.trim()) {
              error = 'Phone is required';
            } else if (!/^\d{10,}$/.test(value)) {
              error = 'Phone must be at least 10 digits';
            }
            break;
          case 'message':
            if (!value.trim()) error = 'Message is required';
            break;
          default:
            break;
        }
        
        return error;
      };
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        
        // Only allow numbers in phone field
        if (name === 'phone' && !/^\d*$/.test(value)) return;
        
        setFormData({
          ...formData,
          [name]: value
        });
    
        // Validate and update error if field was touched or has error
        if (touched[name] || errors[name]) {
          setErrors({
            ...errors,
            [name]: validateField(name, value)
          });
        }
      };
    
      const handleBlur = (e) => {
        const { name } = e.target;
        setTouched({
          ...touched,
          [name]: true
        });
        // Validate the field when it loses focus
        setErrors({
          ...errors,
          [name]: validateField(name, formData[name])
        });
      };
    
      const validateForm = () => {
        let valid = true;
        const newErrors = {};
        
        Object.keys(formData).forEach(key => {
          newErrors[key] = validateField(key, formData[key]);
          if (newErrors[key]) valid = false;
        });
    
        setErrors(newErrors);
        // Mark all fields as touched to show all errors
        setTouched({
          name: true,
          email: true,
          phone: true,
          message: true
        });
        return valid;
      };
    
  const handleSubmit = (e) => {
    e.preventDefault();
    setSendStatus(null);
    const fullMessage = `
      ${formData.message}
      
      Phone: ${formData.phone}
    `;
    if (validateForm()) {
      setIsSending(true);
      
      emailjs.send(
        'service_jhwtks1',   // Replace with your EmailJS Service ID
        'template_5cap9uo',  // Replace with your EmailJS Template ID
        {
            title:"Message from MPTech website",
          name: formData.name,
          from_email: formData.email,
          message: fullMessage,
          to_email: 'mptechnology1t@gmail.com',
          to_email:formData.email,
        },
        'ieXlVasGQyavf-cGH'       // Replace with your EmailJS User ID
      )
      .then(() => {
        setSendStatus('success');
        alert('✓ Email sent successfully!');
        setFormData({ name: '', email: '', phone: '', message: '' });
      })
      .catch(() => {
        setSendStatus('error');
        alert('Failed to send email. Please try again later.');
      })
      .finally(() => {
        setIsSending(false);
      });
    }
  };
    /*end logic */
    return (
      <div>
        <Helmet>
          <title>ام بي تك - Mptech | تواصل معنا</title>
          <link rel="canonical" href={canonicalUrl} />
        </Helmet>
        <div className="contact-container">
           <p className='section-title'>{t('contact.section_title')}</p>
    <h2>{t('contact.section_sub_title')}</h2>
    <p className='about-description-paragraph'>{t('contact.section_description')}</p>
    <div className="contact-form-div">
  <form className="contact-form" onSubmit={handleSubmit}>
      <h3>{t('contact_form.title')}</h3>
  <div className="input-card">
  <label htmlFor="name" className="frm-label">{t('contact_form.name_label')}</label>
  <input type="text" name="name" id="name" placeholder={t('contact_form.name_placeHolder')} className="frm-input" value={formData.name}
            onChange={handleChange}/>
            {(touched.name && errors.name) && <span className="error">{errors.name}</span>}
  </div>
  <div className="input-card">
  <label htmlFor="email" className="frm-label"> {t('contact_form.email_label')}</label>
  <input type="email" name="email" id="email" placeholder={t('contact_form.email_placeHolder')} className="frm-input" value={formData.email}
            onChange={handleChange}/>
            {(touched.email && errors.email) && <span className="error">{errors.email}</span>}
  </div>
  <div className="input-card">
  <label htmlFor="phone" className="frm-label">{t('contact_form.phone_label')}</label>
  <input type="text" name="phone" id="phone" placeholder={t('contact_form.phone_placeHolder')} className="frm-input" value={formData.phone}
            onChange={handleChange}
            inputMode="numeric"/>
            {(touched.phone && errors.phone) && <span className="error">{errors.phone}</span>}
  </div>
  <div className="input-card">
  <label htmlFor="message" className="frm-label">{t('contact_form.message_label')}</label>
  <textarea name="message" id="message" placeholder={t('contact_form.message_placeHolder')} className="frm-input txt-area"  value={formData.message}
            onChange={handleChange}>

  </textarea>
  {(touched.message && errors.message) && <span className="error">{errors.message}</span>}
  <input type="submit" value={t('contact_form.send_btn')} className="send-btn"/>
  </div>
  </form>
    </div>
          
      </div>
      </div>
    );
}